import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FinalUrlSuffixView } from '@bingads-webui-campaign/upgrade-url';

export function FinalUrlSuffix({
  id, value, onChange, legacyI18n,
}) {
  let container;

  const onFinalUrlSuffixUpdated = useCallback(({
    isValid, finalUrlSuffix: newFinalUrlSuffix,
  }) => {
    onChange({ isValid, value: newFinalUrlSuffix });
  }, [onChange]);

  useEffect(() => {
    const view = new FinalUrlSuffixView({
      i18n: legacyI18n,
      editMode: true,
      finalUrlSuffix: value,
      showPlaceholder: true,
    });
    view.on('finalUrlSuffix:updated', onFinalUrlSuffixUpdated);
    view.render().$el.appendTo(container);

    return () => {
      view.remove();
    };
    // We want the view to be created only once,
    // hence ignoring all dependencies of this "effect".
    // This means that view will ignore changes to all props.
    // If need be to make view pick props updates, the view
    // need to provide a way to communicate such update to it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={id} ref={(ref) => { container = ref; }} />
  );
}

FinalUrlSuffix.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  legacyI18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

FinalUrlSuffix.defaultProps = {
  value: '',
};
